import PropTypes from 'prop-types';

import { ChevronLeft, ChevronRight } from '../icons';

const iconClass =
  'flex justify-center items-center w-12 h-12 rounded-md border border-gray-300 text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50  disabled:cursor-not-allowed';

const numberClass = active =>
  `flex justify-center items-center w-12 h-12 text-sm font-medium rounded-md focus:outline-none ${
    active
      ? 'bg-primary-500 text-white border-primary-500'
      : 'text-gray-700 hover:bg-gray-50 border-gray-300 border focus:border-2 focus:border-primary-500'
  }`;

const Pagination = ({ count = 10, page = 1, onChange = () => null }) => (
  <nav className="grid gap-2 grid-flow-col" aria-label="Pagination">
    {/* Previous */}
    <button
      disabled={page <= 1}
      className={iconClass}
      onClick={() => onChange(page - 1)}
    >
      <span className="sr-only">Previous</span>
      <ChevronLeft className="h-5 w-5" />
    </button>

    {/* Pages */}
    {[...new Array(count)].map((_, i) => (
      <button
        key={i}
        className={numberClass(page === i + 1)}
        onClick={() => onChange(i + 1)}
      >
        {i + 1}
      </button>
    ))}

    {/* Next */}
    <button
      disabled={page >= count}
      className={iconClass}
      onClick={() => onChange(page + 1)}
    >
      <span className="sr-only">Next</span>
      <ChevronRight className="h-5 w-5" />
    </button>
  </nav>
);

Pagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  onChange: PropTypes.func,
};

export default Pagination;
